import { create } from 'zustand';

export const useAssetDetailDraftStore = create((set) => ({
    viewMode: 'live',
    hasDraft: false,
    isSubmitted: false,
    draftMode: false,
    linkReadOnly: false,
    workflowLocked: false,
    displayAsset: null,
    linkPayload: null,
    /** Set by AssetDetailDraftProvider — used for save handlers defined outside the provider tree. */
    refreshDraftFn: null,
    setViewModeFn: null,
    setDraftState: (partial) => set((s) => ({ ...s, ...partial })),
    reset: () =>
        set({
            viewMode: 'live',
            hasDraft: false,
            isSubmitted: false,
            draftMode: false,
            linkReadOnly: false,
            workflowLocked: false,
            displayAsset: null,
            linkPayload: null,
            refreshDraftFn: null,
            setViewModeFn: null,
        }),
}));
